module.exports = __webpack_public_path__ + "img/swiper-4.8f3fc42b.jpg";